import React from 'react';
import { Colors } from '@/constants/Colors';
import { useTheme } from '@/hooks/useTheme';

interface FilterChipProps {
  label: string;
  isActive: boolean;
  onPress: () => void;
}

export function FilterChip({ label, isActive, onPress }: FilterChipProps) {
  const colors = useTheme();

  return (
    <button
      onClick={onPress}
      style={{
        ...styles.chip,
        backgroundColor: isActive ? Colors.primary : colors.surface,
        border: isActive ? 'none' : `1px solid ${colors.border}`,
        color: isActive ? '#ffffff' : colors.text,
      }}
    >
      {label}
    </button>
  );
}

const styles: Record<string, React.CSSProperties> = {
  chip: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: 24,
    marginRight: 8,
    fontSize: 14,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    flexShrink: 0,
  },
};
